import ConsultantComparison from './ConsultantComparison';
export default ConsultantComparison;